<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" v-if="user">
      <div class="content container-fluid">
        <div class="row justify-content-lg-center">
          <div class="col-lg-10">
            <componentheader :title="title" />

            <div class="profile-cover">
              <div class="profile-cover-wrap">
                <img
                  class="profile-cover-img"
                  src="@/assets/img/profiles/avatar-02.jpg"
                  alt="Profile Cover"
                />
              </div>
            </div>

            <div class="text-center mb-5">
              <label
                class="avatar avatar-xxl profile-cover-avatar"
                for="avatar_upload"
              >
                <img
                  v-if="user.image"
                  class="avatar-img"
                  :src="user.image"
                  alt="Profile Image"
                />
                <img
                  v-else
                  class="avatar-img"
                  src="@/assets/img/profiles/avatar-02.jpg"
                  alt="Profile Image"
                />
              </label>
              <h2>
                {{ user.name }}
                <!-- <i
                  class="fas fa-certificate text-primary small"
                  data-bs-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Verified"
                ></i> -->
              </h2>
              <ul class="list-inline">
                <li v-if="user.country" class="list-inline-item ms-1">
                  <i class="fas fa-map-marker-alt"></i> {{ user.state }}
                  {{ user.country }}
                </li>
                <li class="list-inline-item ms-1">
                  <i class="far fa-calendar-alt me-1"></i>
                  <span>Joined {{ formatted(user.created_at) }}</span>
                </li>
              </ul>
              <div
                class="mt-2 d-flex align-items-center justify-content-center"
              >
                <b-badge class="fs-6" variant="secondary">{{
                  user.referral_code
                }}</b-badge>
                <button
                  @click="copyCode(user.referral_code)"
                  type="button"
                  style="padding: 2px 10px"
                  class="btn btn-outline-light btn-light ms-4"
                >
                  <i class="fa fa-clone"></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4">
                <div class="card card-body">
                  <h5>Complete your profile</h5>

                  <!-- Progress -->
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="progress progress-md flex-grow-1">
                      <div
                        class="progress-bar bg-primary"
                        role="progressbar"
                        style="width: 70%"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <span class="ms-4">70%</span>
                  </div>
                  <!-- /Progress -->
                </div>

                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title d-flex justify-content-between">
                      <span>Profile</span>
                      <router-link class="btn btn-sm btn-white" to="/settings"
                        >Edit</router-link
                      >
                    </h5>
                  </div>
                  <div class="card-body">
                    <ul class="list-unstyled mb-0">
                      <li class="py-0">
                        <small class="text-dark">About</small>
                      </li>
                      <li>{{ user.name }}</li>
                      <li class="pt-2 pb-0">
                        <small class="text-dark">Contacts</small>
                      </li>
                      <li>{{ user.email }}</li>
                      <li>{{ user.phone }}</li>
                      <li v-if="user.address" class="pt-2 pb-0">
                        <small class="text-dark">Address</small>
                      </li>
                      <li>
                        {{ user.address }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <profiletable1 />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, onMounted } from "vue";
import { formatted } from "@/assets/composables/date";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });

const title = "Profile";

const copyCode = (code) => {
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    // Use the newer Clipboard API if available
    navigator.clipboard.writeText(code).then(() => {
      toast.success("Text copied to clipboard");
    });
  } else {
    // Fallback to the older document.execCommand('copy')
    const textArea = document.createElement("textarea");
    textArea.value = code;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    toast.success("Text copied to clipboard");
  }
};

const user = ref(null);
onMounted(() => {
  user.value = JSON.parse(localStorage.getItem("user"));
});
</script>
